import {useState} from 'react'
import FarmerInputTemplateList from './FarmerInputTemplateList';
import FarmerInputTemplateForm from './FarmerInputTemplateForm';

const FarmerInputTemplate = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
return (
  <>
    {fromIsShown ? (
        <FarmerInputTemplateForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
      ) : (
        <FarmerInputTemplateList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
  )
}

export default FarmerInputTemplate